var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "groupby-editor" },
    [
      _c("SelectPicker", {
        staticClass: "groupby-editor-annotation",
        attrs: {
          "data-class": "btn-default btn-sm",
          "data-width": "auto",
          "data-menu-width": "grow",
          container: "body",
          hideEmpty: "",
          searchable: _vm.annotationOptions.length > 12,
          options: _vm.annotationOptions,
        },
        model: {
          value: _vm.annotation,
          callback: function ($$v) {
            _vm.annotation = $$v
          },
          expression: "annotation",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "groupby-editor-context-container" },
        [
          _c(
            "div",
            { staticClass: "groupby-editor-context btn-group" },
            _vm._l(_vm.contextOptions, function (option) {
              return _c(
                "button",
                {
                  key: option.value,
                  class: [
                    "groupby-editor-context-option",
                    "btn",
                    "btn-default",
                    "btn-sm",
                    {
                      active: _vm.context === option.value,
                    },
                  ],
                  attrs: { type: "button", value: option.value },
                  on: {
                    click: function ($event) {
                      _vm.context = option.value
                    },
                  },
                },
                [_vm._v(_vm._s(option.label))]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("Slider", {
            ref: "slider",
            staticClass: "groupby-editor-slider",
            attrs: {
              tooltip: "never",
              "tooltip-dir": "bottom",
              speed: 0,
              min: 1,
              max: _vm.max,
              width: /*'100px'*/ "auto",
              reverse: _vm.sliderInverted,
            },
            scopedSlots: _vm._u([
              {
                key: "dot",
                fn: function (ref) {
                  var value = ref.value
                  return _c(
                    "div",
                    { staticClass: "groupby-editor-slider-handle" },
                    [_vm._v(_vm._s(value))]
                  )
                },
              },
            ]),
            model: {
              value: _vm.range,
              callback: function ($$v) {
                _vm.range = $$v
              },
              expression: "range",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "groupby-editor-checkboxes" }, [
        _c(
          "div",
          {
            staticClass: "groupby-editor-case-sensitive checkbox",
            attrs: { title: "Treat context case-sensitive" },
          },
          [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.caseSensitive,
                    expression: "caseSensitive",
                  },
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.caseSensitive)
                    ? _vm._i(_vm.caseSensitive, null) > -1
                    : _vm.caseSensitive,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.caseSensitive,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.caseSensitive = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.caseSensitive = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.caseSensitive = $$c
                    }
                  },
                },
              }),
              _vm._v(" Case-sensitive"),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: [
              "groupby-editor-end-of-hit",
              "checkbox",
              { disabled: _vm.context !== "hit" },
            ],
            attrs: {
              title:
                _vm.context !== "hit"
                  ? "Only available for hit context"
                  : "Group the last words in the hit instead of the first",
            },
          },
          [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fromEndOfHit,
                    expression: "fromEndOfHit",
                  },
                ],
                attrs: { type: "checkbox", disabled: _vm.context !== "hit" },
                domProps: {
                  checked: Array.isArray(_vm.fromEndOfHit)
                    ? _vm._i(_vm.fromEndOfHit, null) > -1
                    : _vm.fromEndOfHit,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.fromEndOfHit,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.fromEndOfHit = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.fromEndOfHit = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.fromEndOfHit = $$c
                    }
                  },
                },
              }),
              _vm._v(" From end of hit "),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "groupby-editor-delete btn btn-default btn-sm",
          attrs: { title: "Remove group criteria" },
          on: {
            click: function ($event) {
              return _vm.$emit("delete")
            },
          },
        },
        [_c("span", { staticClass: "fa fa-times fa-lg text-danger" })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }